import { Icon } from "../design-system/Icon";
import { Button } from "../design-system/Button";
import { strings } from "../i18n/es-CL";

export function LoadingState({ label = strings.states.loading }: { label?: string }): JSX.Element {
  return (
    <div className="statecard" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="muted">{label}</span>
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message?: string; onRetry?: () => void }): JSX.Element {
  return (
    <div className="statecard" role="alert">
      <Icon name="alert" size={26} style={{ color: "var(--danger)" }} />
      <div className="strong">{strings.states.error}</div>
      {message ? <div className="faint" style={{ fontSize: 12.5 }}>{message}</div> : null}
      {onRetry ? (
        <Button variant="secondary" size="sm" icon="pulse" onClick={onRetry}>
          {strings.states.retry}
        </Button>
      ) : null}
    </div>
  );
}
